<div class="ui-compact-list">
  @if (rows().length === 0) {
    <p class="ui-compact-list__empty">{{ emptyText() }}</p>
  } @else {
    @if (showHeader()) {
      <div class="ui-compact-list__head" [style.grid-template-columns]="gridTemplate()" aria-hidden="true">
        @for (col of columns(); track col.key) {
          <span [class.ui-compact-list__cell--end]="col.align === 'end'">{{ col.header }}</span>
        }
        @if (showActions()) {
          <span>Acciones</span>
        }
      </div>
    }
    <div class="ui-compact-list__body">
      @for (row of rows(); track rowId(row)) {
        <article class="ui-compact-list__row">
          @if (rowTitle(row); as title) {
            <span class="ui-compact-list__title">{{ title }}</span>
          }
          <div class="ui-compact-list__grid" [style.grid-template-columns]="gridTemplate()">
            @for (col of columns(); track col.key) {
              <span
                class="ui-compact-list__cell"
                [class.ui-compact-list__cell--nowrap]="col.nowrap"
                [class.ui-compact-list__cell--end]="col.align === 'end'"
                [class.ui-compact-list__cell--semibold]="col.semibold"
              >
                @if (col.type === 'tag') {
                  <ui-tag [label]="cellText(col, row)" [color]="cellTagColor(col, row)" />
                } @else {
                  {{ cellText(col, row) }}
                }
              </span>
            }
            @if (showActions()) {
              <div class="ui-compact-list__actions">
                @if (rowActions() === 'view' || rowActions() === 'view-download') {
                  <ui-icon-action icon="view" ariaLabel="Ver" (pressed)="view.emit(row)" />
                }
                @if (rowActions() === 'view-download') {
                  <ui-icon-action
                    icon="download"
                    ariaLabel="Descargar"
                    (pressed)="download.emit(row)"
                  />
                }
                @if (rowActions() === 'edit-delete') {
                  <ui-icon-action icon="edit" ariaLabel="Editar" (pressed)="edit.emit(row)" />
                  <ui-icon-action icon="delete" ariaLabel="Eliminar" (pressed)="delete.emit(row)" />
                }
              </div>
            }
          </div>
          @if (rowTag(row); as tag) {
            <div class="ui-compact-list__detail">
              <ui-tag [label]="tag.label" [color]="tag.color" />
            </div>
          }
        </article>
      }
    </div>
  }
</div>
